import { render, staticRenderFns } from "./DiscountSettingsScreen.vue?vue&type=template&id=7d1d28d4&scoped=true"
import script from "./DiscountSettingsScreen.vue?vue&type=script&lang=js"
export * from "./DiscountSettingsScreen.vue?vue&type=script&lang=js"
import style0 from "./DiscountSettingsScreen.vue?vue&type=style&index=0&id=7d1d28d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1d28d4",
  null
  
)

export default component.exports